import React, { lazy, Suspense, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AddEmployee from "../feature/employee/AddEmployee";
import EmployeeList from "../feature/employee/EmployeeList";
// import ArchivedCityList from "../feature/masterModule/city/ArchivedCityList";
// import CityList from "../feature/masterModule/city/CityList";
import PackageList from "../feature/Package Master/PackageList";
import PodReportdownload from "./../feature/Package Master/PodReportdownload";
import PincodeList from "../feature/masterModule/pincode/PincodeList";
import ZoneList from "../feature/masterModule/zone/ZoneList";
import AreaList from "../feature/masterModule/area/AreaList";

import AddUserRole from "../feature/userRole/AddUserRole";
import UserRoleList from "../feature/userRole/UserRoleList";

import { authUserData, SpinLoading } from "../utils/Helper";

import ActivityLogList from "../feature/activityLog/ActivityLogList";
import ArchiveActivityLog from "../feature/activityLog/ArchiveActivityLog";

import ArchivedEmployeeList from "../feature/employee/ArchivedEmployeeList";

import ArchivedPincodeList from "../feature/masterModule/pincode/ArchivedPincodeList";

import ArchiveZoneList from "../feature/masterModule/zone/ArchiveZoneList";
import ArchiveAreaList from "../feature/masterModule/area/ArchiveAreaList";

import NotAccess from "./NotAccess";

import PaymentSuccessfully from "../authentication/PaymentSuccessfully";

import ArchiveUserRoleList from "../feature/userRole/ArchiveUserRoleList";

import { GetToken } from "../authentication/GetToken";
import ArchivedStreetList from "../feature/masterModule/StreetMaster/ArchivedStreetList";
import StreetList from "../feature/masterModule/StreetMaster/StreetList";
import AddPackage from "../feature/Package Master/AddPackage";
import ArchivePackage from "../feature/Package Master/ArchivePackage";
// import AddSuberb from "../feature/SuberbMaster";
import SuberbList from "../feature/SuberbMaster/SuberbList";
import ArchivedSuberb from "../feature/SuberbMaster/ArchivedSuburb";
import AddSuburb from "../feature/SuberbMaster/AddSuburb";
import Setting from "../feature/setting";
import AddDriver from "../feature/driver/AddDriver";
import ArchiveDriverList from "../feature/driver/ArchiveDriverList";
import DriverList from "../feature/driver/DriverList";
import ArchiveStateList from "../feature/stateMaster/ArchiveStateList";
import StateList from "../feature/stateMaster/StateList";
// import OptimizedRoute from "./../feature/Package Master/OptimizedRoute";
import Routemap from "../feature/Package Master/Routemap";

import Deliveryreport from "../feature/reports/DeliveryReport";
import DriverReport from "../feature/reports/DriverReport";
import ReturnReport from "../feature/reports/ReturnReport";
import CompanyReport from "../feature/reports/CompanyReport";
import Kpicompanyreport from "../feature/reports/KpiCompanyReport";
import Kpidriverreport from "../feature/reports/KpiDriverReport";
import Deliveryrate from "../feature/masterModule/DeliveryrateMaster/DeliveryrateList";
import ModelRouteMap from "../feature/Package Master/ModelRouteMap";
import RouteMapPage from "../feature/Package Master/RouteMapPage";
import AddRoutePackage from "../feature/Package Master/AddRoutePackage";
import AddRoutePickupPackage from "../feature/pickupPackageMaster/AddRoutePickupPackage";
import AddRoutelist from "../feature/Package Master/Routelist";
import Companyonboarding from "../feature/Package Master/CompanyOnboarding";
import AddCompany from "../feature/Package Master/AddCompany";
import ArchiveCompany from "../feature/Package Master/ArchiveCompany";
import ArchiveRoutePackage from "../feature/Package Master/ArchiveRoutePackage";
import EditRoutePackage from "../feature/Package Master/EditRoutePackage";
import PickupPoint from "../feature/Package Master/PickupPoint";
import AddPickupPoint from "../feature/Package Master/AddPickupPoint";
import ArchivePickupPoint from "../feature/Package Master/ArchivePickupPoint";
import Addwarehouse from "../feature/warehouseMaster/AddWarehouse";
import Archivewarehouse from "../feature/warehouseMaster/Archivewarehouse";
import WarehouseList from "../feature/warehouseMaster/WarehouseList";
import PackageMasterList from "../feature/masterModule/packageTypeMaster/PackageTypeMasterList";
import AddPackageMaster from "../feature/masterModule/packageTypeMaster/AddPackageMaster";
import NewDeliveryRateList from "../feature/masterModule/DeliveryrateMaster/NewDeliveryRateList";
import NewAddDriver from "../feature/driver/NewAddDriver";
import PickupPointLoginList from "../feature/pickupPointLogin/PickupPointLoginList";
import MyCompany from "../feature/myCompany/MyCompany";
import MyPickupPoint from "../feature/myPickupPoint/MyPickupPoint";
import PickupPointPackage from "../feature/Package Master/PickupPointPackage";
import ReturnPackage from "../feature/ReturnPackage/ReturnList";
import CompanyPodReport from "../feature/myCompany/CompanyPodReport";
import { ReturnPortalScan } from "../feature/ReturnPackage/ReturnPortalScan";

import AddDepoManager from "../feature/DepoManager/AddDepoManager";
import MyDepoManager from "../feature/DepoManager/MyDepoManager";
import ArchiveDepoManager from "../feature/DepoManager/ArchiveDepoManager";
import DepoManager from "../feature/DepoManager/DepoManager";
import DepoManagerLoginList from "../feature/DepoManager/DepoManagerLoginList";
import CompanyLoginKpiReport from "../feature/reports/CompanyLoginKpiReport";
import PackageViewForDepoManager from "../feature/DepoManager/PackageViewForDepoManager";
import ScannedPackageList from "../feature/Package Master/ScannedPackageList";
import DeliveredPackageList from "../feature/Package Master/DeliveredPackageList";
import NotScannedPackageList from "../feature/Package Master/NotScannedPackageList";
import CompanyRateCard from "../feature/myCompany/CompanyRateCard";
import PickupPackageList from "../feature/pickupPackageMaster/PickupPackageList";
import AddPickupPackage from "../feature/pickupPackageMaster/AddPickupPackage";
import ArchivePickupPackage from "../feature/pickupPackageMaster/ArchivePickupPackage";
import PrintMultiplePackages from "../authentication/PrintMultiplePackages";
import PickupRoutelist from "../feature/pickupPackageMaster/PickupRouteList";
import WalletAdminPrepaid from "../feature/wallet/WalletAdminPrepaid";
// import WalletAdminPostpaid from "../feature/wallet/WalletAdminPostpaid";
import WalletCompany from "../feature/wallet/WalletCompany";
import TransactionListAdmin from "../feature/wallet/TransactionListAdmin";
import WalletAdminPostpaid from "../feature/wallet/WallerAdminPostpaid";
import PaymentSuccessWallet from "../feature/wallet/PaymentSuccessWallet";
import InvoiceListAdmin from "../feature/invoice/InvoiceListAdmin";
import InvoiceListCompany from "../feature/invoice/InvoiceListCompany";
import AdjustmentListCompany from "../feature/adjustmentWallet/AdjustmentListCompany";
import AdjustmentListAdmin from "../feature/adjustmentWallet/AdjustmentListAdmin";
import BillingReportAdmin from "../feature/wallet/BillingReportAdmin";
import CompanyWiseBillingReportAdmin from "../feature/wallet/CompanyWiseBillingReportAdmin";
import AcceptCompanyKey from "../feature/myCompany/AcceptCompanyKey";
import AcceptCompanyKeyAdd from "../feature/myCompany/AcceptCompanyKeyAdd";
import AdminPodReport from "../feature/Package Master/AdminPodReport";
import ShipmentTracking from "../feature/shipmentTracking/ShipmentTracking";

const Login = lazy(() => import("../authentication/Login"));

const CompanyDetailsPopup = lazy(() =>
  import("../authentication/CompanyDetailsPopup")
);
const PrintPackage = lazy(() => import("../authentication/PrintPackage"));

const ForgotSuccess = lazy(() => import("../authentication/ForgotSuccess"));
const ForgotPassword = lazy(() => import("../authentication/ForgotPassword"));
const ResetPassword = lazy(() => import("../authentication/ResetPassword"));
// const ResetPasswordNew = lazy(() =>
//   import("../authentication/ResetPasswordNew")
// );
const TermsConditions = lazy(() => import("../authentication/TermsConditions"));

const Logout = lazy(() => import("../authentication/Logout"));

const Dashboard = lazy(() => import("../feature/dashboard/Dashboard"));

// const NotFound = lazy(() => import("./NotFound"));
// const NotAccess = lazy(() => import("./NotAccess"));
const PrivateRoute = lazy(() => import("./PrivateRoute"));

const EditProfile = lazy(() => import("../feature/profile/EditProfile"));
const UserList = lazy(() => import("../feature/user/UserList"));
const AddUser = lazy(() => import("../feature/user/AddUser"));

const Root = () => {
  const [pageLoaded, setPageLoaded] = useState(
    document.readyState === "complete"
  );
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  // const token = GetToken();

  useEffect(() => {
    const token = GetToken();
    if (token && token !== null) {
      setIsAuthenticated(true);
    }
  }, []);

  const keepMe = authUserData()?.keep_me_logged_in;

 
  const superAdmin = authUserData()?.last_name === "Admin";
  const supervisor = authUserData()?.group[0].name === "Supervisor";

  useEffect(() => {
    const handleLoad = () => {
      setPageLoaded(true);
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", handleLoad);
    } else {
      handleLoad();
    }

    return () => {
      document.removeEventListener("DOMContentLoaded", handleLoad);
    };
  }, []);

  return (
    <>
      {pageLoaded ? (
        <Suspense fallback={<SpinLoading />}>
          <Routes>
            <>
              {isAuthenticated && keepMe ? (
                <Route
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <Dashboard />
                    </Suspense>
                  }
                />
              ) : (
                <Route
                  path="/"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <Login />
                    </Suspense>
                  }
                />
              )}

              <Route
                path="/login"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <Login />
                  </Suspense>
                }
              />

              <Route
                path="/new-company-register"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <CompanyDetailsPopup />
                  </Suspense>
                }
              />

              <Route
                path="/terms-and-conditions"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <TermsConditions />
                  </Suspense>
                }
              />
              <Route
                path="/delivery-report"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <Deliveryreport />
                  </Suspense>
                }
              />

              {/* <Route
                path="/Optimized-Route"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <OptimizedRoute />
                  </Suspense>
                }
              /> */}
              <Route
                path="/payment-successfully"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <PaymentSuccessfully />
                  </Suspense>
                }
              />

              <Route
                path="/reset-password/:resetToken"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <ResetPassword />
                  </Suspense>
                }
              />
              {/* <Route
                path="/reset-password/"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <ResetPasswordNew />
                  </Suspense>
                }
              /> */}
              <Route
                path="/forgot-password"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <ForgotPassword />
                  </Suspense>
                }
              />
              <Route
                path="/mail-sent"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <ForgotSuccess />
                  </Suspense>
                }
              />
              <Route
                path="/print-label/:id"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <PrintPackage />
                  </Suspense>
                }
              />
              <Route
                path="/print-labels/"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <PrintMultiplePackages />
                  </Suspense>
                }
              />

              <Route
                path="/logout"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <Logout />
                  </Suspense>
                }
              />

              <Route
                exact
                path="/"
                element={
                  <Suspense fallback={<SpinLoading />}>
                    <PrivateRoute />
                  </Suspense>
                }
              >
                <Route
                  path="/dashboard"
                  element={
                    isAuthenticated ? <Dashboard /> : <Navigate to="/" />
                  }
                />
                {isAuthenticated && keepMe ? (
                  <Route
                    path="/"
                    element={
                      <Suspense fallback={<SpinLoading />}>
                        <Dashboard />
                      </Suspense>
                    }
                  />
                ) : (
                  <Route path="/" element={<Navigate to="/login" replace />} />
                )}
                <Route
                  path="/my-profile"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <EditProfile />
                    </Suspense>
                  }
                />

                <Route
                  path="/user"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <UserList />
                    </Suspense>
                  }
                />
                <Route
                  path="/user/add"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddUser />
                    </Suspense>
                  }
                />
                <Route
                  path="/user/edit/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddUser />
                    </Suspense>
                  }
                />
                <Route
                  path="/user-role"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <UserRoleList />
                    </Suspense>
                  }
                />
                <Route
                  path="/user-role/add"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddUserRole />
                    </Suspense>
                  }
                />
                <Route
                  path="/user-role/edit/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddUserRole />
                    </Suspense>
                  }
                />
                <Route
                  path="/user-role/archive"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ArchiveUserRoleList />
                    </Suspense>
                  }
                />

                {/* <Route
                  path="/city"
                  element={superAdmin ? <CityList /> : <Navigate to="/" />}
                />

                <Route
                  path="/city/archive"
                  element={
                    superAdmin ? <ArchivedCityList /> : <Navigate to="/" />
                  }
                /> */}
                <Route
                  path="/prepaid-wallet"
                  element={
                    isAuthenticated ? (
                      <WalletAdminPrepaid />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/postpaid-wallet"
                  element={
                    isAuthenticated ? (
                      <WalletAdminPostpaid />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/transaction-list"
                  element={
                    isAuthenticated ? (
                      <TransactionListAdmin />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/invoice-list"
                  element={
                    isAuthenticated ? <InvoiceListAdmin /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/my-invoice"
                  element={
                    isAuthenticated ? (
                      <InvoiceListCompany />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/adjustment-list"
                  element={
                    isAuthenticated ? (
                      <AdjustmentListAdmin />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/billing-report"
                  element={
                    isAuthenticated ? (
                      <BillingReportAdmin />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/company-wise-billing-report"
                  element={
                    isAuthenticated ? (
                      <CompanyWiseBillingReportAdmin />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/my-adjustment"
                  element={
                    isAuthenticated ? (
                      <AdjustmentListCompany />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/my-wallet"
                  element={
                    isAuthenticated ? <WalletCompany /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/payment-success"
                  element={
                    isAuthenticated ? (
                      <PaymentSuccessWallet />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/employee"
                  element={
                    isAuthenticated ? <EmployeeList /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/employee/add"
                  element={
                    isAuthenticated ? <AddEmployee /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/employee/archive"
                  element={
                    isAuthenticated ? (
                      <ArchivedEmployeeList />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />

                <Route
                  path="/employee/edit/:id"
                  element={
                    isAuthenticated ? <AddEmployee /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/suburb"
                  element={
                    isAuthenticated ? <SuberbList /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/suburb/add"
                  element={
                    isAuthenticated ? <AddSuburb /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/suburb/edit/:id"
                  element={
                    isAuthenticated ? <AddSuburb /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/suburb/archive"
                  element={
                    isAuthenticated ? <ArchivedSuberb /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/run"
                  element={(superAdmin || supervisor)? <ZoneList /> : <Navigate to="/" />}
                />

                <Route
                  path="/run/archive"
                  element={
                    (superAdmin || supervisor) ? <ArchiveZoneList /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/customer-zone"
                  element={(superAdmin || supervisor)? <AreaList /> : <Navigate to="/" />}
                />

                <Route
                  path="/customer-zone/archive"
                  element={
                    (superAdmin || supervisor)? <ArchiveAreaList /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/state"
                  element={superAdmin ? <StateList /> : <Navigate to="/" />}
                />
                <Route
                  path="/package-master-list"
                  element={
                    superAdmin ? <PackageMasterList /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/package-master-list/add"
                  element={
                    superAdmin ? <AddPackageMaster /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/package-master-list/edit/:id"
                  element={
                    superAdmin ? <AddPackageMaster /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/state/archive"
                  element={
                    superAdmin ? <ArchiveStateList /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/pincode"
                  element={superAdmin ? <PincodeList /> : <Navigate to="/" />}
                />

                <Route
                  path="/new-delivery-rate-list"
                  element={
                    superAdmin ? <NewDeliveryRateList /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/new-add-driver"
                  element={superAdmin ? <NewAddDriver /> : <Navigate to="/" />}
                />
                <Route
                  path="/street"
                  element={superAdmin ? <StreetList /> : <Navigate to="/" />}
                />

                <Route
                  path="/pincode/archive"
                  element={
                    superAdmin ? <ArchivedPincodeList /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/deliveryrate"
                  element={superAdmin ? <Deliveryrate /> : <Navigate to="/" />}
                />

                <Route
                  path="/street/archive"
                  element={
                    superAdmin ? <ArchivedStreetList /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/add-route"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddRoutePackage />
                    </Suspense>
                  }
                />
                <Route
                  path="/add-pickup-route"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddRoutePickupPackage />
                    </Suspense>
                  }
                />
                <Route
                  path="/add-route/edit/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <EditRoutePackage />
                    </Suspense>
                  }
                />
                <Route
                  path="/my-pickup-point"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <MyPickupPoint />
                    </Suspense>
                  }
                />
                <Route
                  path="/company-onboarding"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <Companyonboarding />
                    </Suspense>
                  }
                />

                <Route
                  path="/company/add"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddCompany />
                    </Suspense>
                  }
                />
                <Route
                  path="/company/edit/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddCompany />
                    </Suspense>
                  }
                />
                <Route
                  path="/company/archive"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ArchiveCompany />
                    </Suspense>
                  }
                />
                <Route
                  path="/pickup-point"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <PickupPoint />
                    </Suspense>
                  }
                />
                <Route
                  path="/pickup-point-login"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <PickupPointLoginList />
                    </Suspense>
                  }
                />

                <Route
                  path="/pickup-point/add"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddPickupPoint />
                    </Suspense>
                  }
                />
                <Route
                  path="/pickup-point/edit/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddPickupPoint />
                    </Suspense>
                  }
                />
                <Route
                  path="/pickup-point/archive"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ArchivePickupPoint />
                    </Suspense>
                  }
                />

                <Route
                  path="/podreport-download"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <PodReportdownload />
                    </Suspense>
                  }
                />
                <Route
                  path="/my-depo-manager"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <MyDepoManager />
                    </Suspense>
                  }
                />
                <Route
                  path="/depo-manager"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <DepoManager />
                    </Suspense>
                  }
                />
                <Route
                  path="/depo-manager-login"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <DepoManagerLoginList />
                    </Suspense>
                  }
                />
                <Route
                  path="/depo-manager/add"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddDepoManager />
                    </Suspense>
                  }
                />
                <Route
                  path="/depo-manager/edit/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddDepoManager />
                    </Suspense>
                  }
                />
                <Route
                  path="/depo-manager/archive"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ArchiveDepoManager />
                    </Suspense>
                  }
                />
                <Route
                  path="/route-list"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddRoutelist />
                    </Suspense>
                  }
                />
                <Route
                  path="/pickup-route-list"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <PickupRoutelist />
                    </Suspense>
                  }
                />
                <Route
                  path="/add-route/archive"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ArchiveRoutePackage />
                    </Suspense>
                  }
                />
                <Route
                  path="/my-company"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <MyCompany />
                    </Suspense>
                  }
                />
                <Route
                  path="/admin-package-pod"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AdminPodReport />
                    </Suspense>
                  }
                />
                <Route
                  path="/company-package-pod"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <CompanyPodReport />
                    </Suspense>
                  }
                />
                <Route
                  path="/company-rate-card"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <CompanyRateCard />
                    </Suspense>
                  }
                />

                <Route
                  path="/package"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <PackageList />
                    </Suspense>
                  }
                />

                <Route
                  path="/package/add"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddPackage />
                    </Suspense>
                  }
                />
                <Route
                  path="/package/edit/:id"
                  element={
                    isAuthenticated ? <AddPackage /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/package/view/:id"
                  element={
                    isAuthenticated ? (
                      <PackageViewForDepoManager />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/package/archive"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ArchivePackage />
                    </Suspense>
                  }
                />
                <Route
                  path="/pickup-package"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <PickupPackageList />
                    </Suspense>
                  }
                />
                <Route
                  path="/pickup-package/add"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddPickupPackage />
                    </Suspense>
                  }
                />
                <Route
                  path="/pickup-package/edit/:id"
                  element={
                    isAuthenticated ? <AddPickupPackage /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/pickup-package/archive"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ArchivePickupPackage />
                    </Suspense>
                  }
                />
                <Route
                  path="/pickup-point-package"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <PickupPointPackage />
                    </Suspense>
                  }
                />
                <Route
                  path="/driver"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <DriverList />
                    </Suspense>
                  }
                />
                <Route
                  path="/driver/edit/:id"
                  element={
                    isAuthenticated ? <AddDriver /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/driver/add"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AddDriver />
                    </Suspense>
                  }
                />
                <Route
                  path="/driver/archive"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ArchiveDriverList />
                    </Suspense>
                  }
                />
                <Route
                  path="/settings"
                  element={isAuthenticated ? <Setting /> : <Navigate to="/" />}
                />

                {/* <Route
                  path="/optimized-route"
                  element={
                    isAuthenticated ? <OptimizedRoute /> : <Navigate to="/" />
                  }
                /> */}
                <Route
                  path="/optimized-route"
                  element={isAuthenticated ? <Routemap /> : <Navigate to="/" />}
                />
                <Route
                  path="/optimized-route-modal"
                  element={
                    isAuthenticated ? <ModelRouteMap /> : <Navigate to="/" />
                  }
                />
                <Route
                  path="/optimized-route-main"
                  element={
                    isAuthenticated ? <RouteMapPage /> : <Navigate to="/" />
                  }
                />

                <Route
                  path="/return-package"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ReturnPackage />
                    </Suspense>
                  }
                />

                <Route
                  path="/return-portal"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ReturnPortalScan />
                    </Suspense>
                  }
                />
                <Route
                  path="/accept-company-key"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AcceptCompanyKey />
                    </Suspense>
                  }
                />
                <Route
                  path="/accept-company-key/add"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AcceptCompanyKeyAdd />
                    </Suspense>
                  }
                />
                <Route
                  path="/accept-company-key/edit/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <AcceptCompanyKeyAdd />
                    </Suspense>
                  }
                />

                <Route
                  path="/activity-log"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ActivityLogList />
                    </Suspense>
                  }
                />
                  <Route
                  path="/shipment-tracking"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ShipmentTracking />
                    </Suspense>
                  }
                />

                <Route
                  path="/activity-log/archive"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ArchiveActivityLog />
                    </Suspense>
                  }
                />

                <Route
                  path="/not-access"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <NotAccess />
                    </Suspense>
                  }
                />

                <Route
                  path="/driver-report"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <DriverReport />
                    </Suspense>
                  }
                />
                <Route
                  path="/return-report"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ReturnReport />
                    </Suspense>
                  }
                />
                <Route
                  path="/company-kpi-report"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <CompanyLoginKpiReport />
                    </Suspense>
                  }
                />
                <Route
                  path="/scanned-package-list"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <ScannedPackageList />
                    </Suspense>
                  }
                />
                <Route
                  path="/delivered-package-list"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <DeliveredPackageList />
                    </Suspense>
                  }
                />
                <Route
                  path="/not-scanned-package-list"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <NotScannedPackageList />
                    </Suspense>
                  }
                />
                <Route
                  path="/company-report"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <CompanyReport />
                    </Suspense>
                  }
                />
                <Route
                  path="/kpi-driverreport"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <Kpidriverreport />
                    </Suspense>
                  }
                />
                <Route
                  path="/kpi-companyreport"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <Kpicompanyreport />
                    </Suspense>
                  }
                />

                <Route
                  path="/warehouse"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <WarehouseList />
                    </Suspense>
                  }
                />
                <Route
                  path="/warehouse/add"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <Addwarehouse />
                    </Suspense>
                  }
                />
                <Route
                  path="/warehouse/edit/:id"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <Addwarehouse />
                    </Suspense>
                  }
                />
                <Route
                  path="/warehouse/archive"
                  element={
                    <Suspense fallback={<SpinLoading />}>
                      <Archivewarehouse />
                    </Suspense>
                  }
                />
              </Route>
            </>
          </Routes>
        </Suspense>
      ) : (
        <Routes>
          <Route
            path="*"
            element={
              <Suspense fallback={<SpinLoading />}>
                <Login />
              </Suspense>
            }
          />
        </Routes>
      )}
    </>
  );
};

export default Root;
